import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: "Confirmer l'adresse e-mail",
  [OnboardingStep.BusinessInfo]: 'Ajouter les détails de votre boutique',
  [OnboardingStep.PersonalInfo]: 'Ajouter vos informations personnelles',
  [OnboardingStep.ShippingInfo]: 'Ajouter vos informations de livraison',
  [OnboardingStep.BankInfo]: 'Ajouter les coordonnées bancaires pour les versements',
  [OnboardingStep.TaxInfo]: 'Votre entreprise est-elle assujettie à la TVA ?',
  [OnboardingStep.BusinessDocs]: "Justificatif d'entreprise",
  [OnboardingStep.PersonalDocs]: "Justificatif d'identité",
  [OnboardingStep.InfoSubmission]: 'Recevoir un paiement',
  confirm_info_gateway: 'Recevoir un paiement – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informations de paiement',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Application mobile',
  [OnboardingStep.DeliveryStructure]: 'Structure de livraison',
  [OnboardingStep.Contract]: 'Contrat',
  [OnboardingStep.ContractPayment]: 'Paiement du contrat',
  [OnboardingStep.PromoCode]: 'Code promo',
};
